var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmarkSavedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.666,
    height: 21.192
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.083 7.015l-3.1-3.1 1.229-1.255 1.871 1.871L19.409.176l1.257 1.257zM0 21.192V1.75A1.8 1.8 0 011.754 0h9.822a5.413 5.413 0 00-1.008 1.622 5.148 5.148 0 00-.336 1.885 5.082 5.082 0 001.257 3.42 5.169 5.169 0 003.128 1.783 6.606 6.606 0 001.754 0v12.482l-8.185-3.508z",
    fill: "#1069ec"
  })));
}

export default SvgBookmarkSavedIcon;